// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 256 ? "purchase" : chunkId) + "." + {"107":"20c096ff","256":"85f2302d","494":"ed7fa691","951":"8fa1762c"}[chunkId] + ".css";
};